import {businessReferralsAdminEndpoints} from '@registry';
import {defineStore} from 'pinia';

export const useReferralsAdminStore = defineStore('referrals-admin-store', () => {
    async function createMissingReferredProjectDeliverable(referralId: string, referredProjectId: string) {
        await businessReferralsAdminEndpoints.createMissingReferredProjectDeliverable({
            referralId,
            createMissingReferredProjectDeliverableRequest: {referredProjectId},
        });
    }

    return {
        createMissingReferredProjectDeliverable,
    };
});
